// extracted by mini-css-extract-plugin
export default {"container":"tq-z","heading":"uq-z","text":"vq-z","info":"wq-z","link":"xq-z","fullMaxWidth":"yq-z"};